import { render, staticRenderFns } from "./ScReviewView.vue?vue&type=template&id=6a1a03ea&scoped=true&"
import script from "./ScReviewView.vue?vue&type=script&lang=js&"
export * from "./ScReviewView.vue?vue&type=script&lang=js&"
import style1 from "./ScReviewView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a03ea",
  null
  
)

export default component.exports